import i18n from './i18n';
import RecipientsInput from './RecipientsInput';

export { i18n };
export * from './SelectedRecipientItem';
export * from './SelectedRecipients';
export * from './focusCampo';
export default RecipientsInput;
